var exports = {
  "kL": "IpAuthorizationScreen.module__container___a2lVai",
  "Kk": "IpAuthorizationScreen.module__icon___a2lVai",
  "DD": "IpAuthorizationScreen.module__title___a2lVai",
  "h_": "IpAuthorizationScreen.module__description___a2lVai",
  "o1": "IpAuthorizationScreen.module__actions___a2lVai",
};

module.exports = exports;
